export default __webpack_public_path__ + "static/media/Blog12.16.ef037ae4.png";